<template>
  <div :class="isApp ? 'lottery' : ''">
    <top-header
      :type="3"
      :isShow="false"
      :bgColor="bgColor"
      :textColor="textColor"
    />
    <div class="top_banner" ref="topBanner">
      <swiper class="swiper" :options="swiperOptionh" ref="mySwiper">
        <swiper-slide v-if="videoList.length">
          <swiper class="swiper vertical" :options="swiperOptionv">
            <swiper-slide
              class="slide_video_con"
              v-for="(item, index) in videoList"
              :key="index"
            >
              <div class="cover m_flex_box flex_hc flex_vc" @click="showModel">
                <van-icon name="play-circle-o" />
              </div>
              <img :src="imgPath + 'sVideo/' + item.imgId + '.jpg'" alt="" />
            </swiper-slide>
          </swiper>
        </swiper-slide>
        <swiper-slide>
          <swiper class="swiper vertical" :options="swiperOptionv">
            <swiper-slide
              class="slide_video_con"
              v-for="(item, index) in swiperImg"
              :key="index"
            >
              <img
                @click="showModel"
                :src="imgPath + 'sImgMax/' + item.imgid + '.jpg'"
                alt=""
              />
            </swiper-slide>
            <swiper-slide v-if="!videoList.length && !swiperImg.length">
              <img v-lazy="" alt="" />
            </swiper-slide>
          </swiper>
        </swiper-slide>
      </swiper>
      <div class="total">共{{ swiperImg.length + videoList.length }}张</div>
      <div class="pagination m_flex_box flex_vc flex_hc">
        <span
          v-if="videoList.length"
          :class="topSwiperIndex === 0 ? 'active' : ''"
          @click="toSlide(0)"
          >视频</span
        >
        <span :class="topSwiperIndex === 1 ? 'active' : ''" @click="toSlide(1)"
          >图片</span
        >
      </div>
    </div>
    <div class="top_info">
      <div class="m_flex_box flez_vc flex_jz top">
        <h3 class="line_comp1">{{ obj.tgmc ? obj.tgmc : "-" }}</h3>
        <p class="price">
          均价<span>{{ obj.priceStr }}</span
          ><span v-if="obj.priceStr !== '暂无'">元/m²</span>
        </p>
      </div>
      <div class="m_flex_box flex_vc flex_jz">
        <div class="score m_flex_box flex_vc">
          <img
            src="@/assets/img/star.png"
            alt=""
            v-for="item in obj.zScore"
            :key="item"
          />
          <img
            src="@/assets/img/star_.png"
            v-for="item in 5 - zScore"
            :key="item + '_'"
            alt=""
          />
          <span>{{ obj.zScore ? obj.zScore : 0 }}分</span>
        </div>
        <p class="fwl">
          浏览量<span>{{ obj.fwl || 0 }}</span>
        </p>
      </div>
      <div class="icon m_flex_box flex_vc">
        <span>{{ obj.xsqkStr ? obj.xsqkStr : "-" }}</span>
        <div v-for="(item, index) in obj.xmts" :key="index">
          <p v-if="index < 4">
            <i>{{ item }}</i>
          </p>
        </div>
      </div>
      <!-- <div class="m_flex_box flex_vc flex_jz middle_blue">
        <p class="left m_flex_box flex_vc" @click="toProject">
          <img src="@/assets/img/mf.png" alt="" />
          <span>查看项目详情</span>
        </p>
        <p class="right m_flex_box flex_vc" @click="toOneHouse">
          <img src="@/assets/img/con_.png" alt="" />
          <span>查看一房一价</span>
        </p>
      </div> -->
    </div>
    <div class="text_con">
      <p class="row m_flex_box flex_vc">
        备案名称<span class="line_comp1">{{ obj.xmmc || "-" }}</span>
      </p>
      <div class="m_flex_box flex_vc flex_jz">
        <p class="row m_flex_box flex_vc flex-1">
          最新预售<span class="line_comp1">{{
            obj.kpsj | timeFormat("yyyy-MM-dd")
          }}</span>
        </p>
        <p class="row m_flex_box flex_vc flex-1">
          上房时间<span class="line_comp1">{{
            obj.sfsj | timeFormat("yyyy-MM-dd")
          }}</span>
        </p>
      </div>
      <p class="row m_flex_box flex_vc">
        开发企业<span class="line_comp1">{{ obj.corpName || "-" }}</span>
      </p>
      <p class="row m_flex_box flex_vc">
        售楼处地址<span class="line_comp1">{{ obj.xsdz || "-" }}</span>
      </p>
      <p class="row m_flex_box flex_vc">
        项目地址<span class="line_comp1">{{ obj.xmdz || "-" }}</span>
      </p>
    </div>
    <div class="mid_pad" v-show="showPad"></div>
    <!-- <div class="detail_nav_bar" :class="showPad ? 'fixed' : ''">
      <span :class="tabIndex === 0 ? 'active' : ''">楼盘首页</span>
      <span @click="toUrl('/projectXq')">楼盘详情</span>
      <span @click="toUrl('/saleInfo')">销售状态</span>
      <span @click="toUrl('/oneHouseOnePrice')">一房一价</span>
      <span @click="toUrl('/sameHouseList')">二手房源</span>
      <span @click="toUrl('/newsList')">楼盘动态</span>
      <span @click="toUrl('/newsList', 1)">楼盘快讯</span>
      <span @click="toUrl('/photo')">楼盘相册</span>
      <span @click="toUrl('/argumentList')">楼盘点评</span>
      <span @click="toUrl('/fundSupervision')">资金监管</span>
    </div> -->
    <div class="pad_top_inner"></div>
    <!-- <div class="bor_b" v-if="personList.length">
      <div class="main_inner">
        <div class="m_flex_box flex_vc flex_jz tit_con">
          <h3 class="inner_tit">置业顾问</h3>
        </div>
        <div class="people_con">
          <div class="inner" v-for="(item, index) in personList" :key="index">
            <img
              v-if="item.lxStr === '置业顾问'"
              :src="item.tx ? imgPath + 'sTx/' + item.tx + '.jpg' : pic"
              alt=""
              class="atavr"
            />
            <img
              v-else
              :src="
                item.brokerImg
                  ? imgPath + 'sClf/' + item.brokerImg + '.jpg'
                  : pic
              "
              alt=""
              class="atavr"
            />
            <p class="name">
              {{ item.brokerName ? item.brokerName : item.realName }}
            </p>
            <p class="intro">{{ item.lxStr }}</p>
            <div class="btn_con m_flex_box flex_vc flex_jz">
              <div @click="toTalk(item.id)">
                <img src="@/assets/img/zx.png" alt="" />
                <p>在线咨询</p>
              </div>
              <a
                @click.stop="
                  callTo(
                    item.phone,
                    item.lxStr === '房产经纪人' ? 1 : 2,
                    item.id
                  )
                "
              >
                <img src="@/assets/img/phone.png" alt="" />
                <p>电话联系</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="bor_b">
      <div class="main_inner announce_main">
        <div class="m_flex_box flex_vc flex_jz tit_con">
          <h3 class="inner_tit">预售信息</h3>
        </div>
        <div>
          <div class="announce_list">
            <div class="row m_flex_box flex_vc">
              <span>预售许可证</span
              >{{ checkData.ysxkzh != "" ? checkData.ysxkzh : "-" }}
            </div>
            <div class="row m_flex_box flex_vc">
              <span>预售范围</span>
              {{ checkData.ysfw != "" ? checkData.ysfw : "-" }}
            </div>
            <div class="row m_flex_box flex_vc">
              <span>入网套数</span
              >{{ checkData.houseCount ? checkData.houseCount : "-" }}
            </div>
            <!-- <div class="row m_flex_box flex_vc">
              <span>不可售套数</span
              >{{ checkData.bksHouseCount ? checkData.bksHouseCount : "-" }}
            </div> -->
            <div class="row m_flex_box flex_vc">
              <span>可售商品房住房套数</span>
              {{ checkData.kszzCount ? checkData.kszzCount : "-" }}
            </div>
            <div class="row m_flex_box flex_vc">
              <span>报名人数</span>
              {{ checkData.bmCount ? checkData.bmCount : "-" }}
            </div>
            <div class="row m_flex_box flex_vc">
              <span>报名比例</span>
              {{ checkData.bmRatio ? checkData.bmRatio : "-" }}
            </div>
            <div class="row m_flex_box flex_vc">
              <span>是否双限项目</span>
              {{
                checkData.doubleLimit
                  ? checkData.doubleLimit == 1
                    ? "是"
                    : "否"
                  : "-"
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bor_b">
      <div class="main_inner announce_main">
        <div class="m_flex_box flex_vc flex_jz tit_con">
          <h3 class="inner_tit">报名及摇号进度公示</h3>
        </div>
        <div class="m_lotter">
          <div>
            <span>当前状态:</span>
            <span style="font-size: 0.3rem">{{ currentState }}</span>
          </div>
          <div class="m_flex_lotter">
            <ul>
              <li>
                <div class="lotter_point">
                  <img :src="stepImg1" alt="" @click="clickStep1" />
                  <div class="line">
                    <img :src="stepImgOne" alt="" />
                  </div>
                </div>
                <div class="lotter_step">预售办理中</div>
                <div class="lotter_dec">
                  取得预售后,在报名时间段内可以选择项目报名
                </div>
              </li>
              <li>
                <div class="lotter_point">
                  <img :src="stepImg2" alt="" @click="clickStep2" />
                  <div class="line">
                    <img :src="stepImgTwo" alt="" />
                  </div>
                </div>
                <div class="lotter_step">报名中</div>
                <div class="lotter_dec">
                  请用购房者使用手机报名，录入报名信息并提交相关材料材料。
                </div>
              </li>
              <li>
                <div class="lotter_point">
                  <img :src="stepImg3" alt="" @click="clickStep3" />
                  <div class="line">
                    <img :src="stepImgThree" alt="" />
                  </div>
                </div>
                <div class="lotter_step">摇号公示</div>
                <div class="lotter_dec">
                  当报名数大于等于可售商品住宅房源数2倍时(双限项目为1倍)，将由公证处进行摇号确认购房名单及选房顺序。当报名数小于可售商品住宅房源数2倍时(双限项目为1倍)，将交由开发企业自行销售。
                </div>
              </li>
              <li>
                <div class="lotter_point">
                  <img :src="stepImg4" alt="" @click="clickStep4" />
                </div>
                <div class="lotter_step">认购公示</div>
                <div class="lotter_dec">开发企业根据选房名单进行房源认购。</div>
              </li>
            </ul>
          </div>
          <div class="m_dec">
            <div class="lotter_list" v-show="selectedStep == 1">
              <div class="row m_flex_box flex_vc">
                <span>当前进度</span>
                {{ checkStepOne.jd ? checkStepOne.jd : "-" }}
              </div>
              <div class="row m_flex_box flex_vc">
                <span>更新时间</span>
                {{ checkStepOne.updateDate ? checkStepOne.updateDate : "-" }}
              </div>
            </div>
            <div class="lotter_list" v-show="selectedStep == 2">
              <div class="row m_flex_box flex_vc">
                <span>报名时间进度</span>
                {{ checkStepTwo.bmsjjd ? checkStepTwo.bmsjjd : "-" }}
              </div>
              <div class="row m_flex_box flex_vc">
                <span>房源套数</span>
                {{ checkStepTwo.kszzCount ? checkStepTwo.kszzCount : "-" }}
              </div>
              <div class="row m_flex_box flex_vc">
                <span>当前报名人数</span>
                {{ checkStepTwo.bmCount ? checkStepTwo.bmCount : "-" }}
              </div>
              <div class="row m_flex_box flex_vc">
                <span>报名比例</span>
                {{ checkStepTwo.bmRatio ? checkStepTwo.bmRatio : "-" }}
              </div>
              <div class="row m_flex_box flex_vc">
                <span>报名开始时间:</span>
                {{ checkStepTwo.bmkssj ? checkStepTwo.bmkssj : "-" }}
              </div>
              <div class="row m_flex_box flex_vc">
                <span>报名结束时间:</span>
                {{ checkStepTwo.bmjssj ? checkStepTwo.bmjssj : "-" }}
              </div>
              <div class="row m_flex_box flex_vc">
                <span>计划摇号时间</span>
                {{ checkStepTwo.jhyhsj ? checkStepTwo.jhyhsj : "-" }}
              </div>
              <div class="row m_flex_box flex_vc">
                <span>计划摇号地点</span>
                {{ checkStepTwo.jhyhdd ? checkStepTwo.jhyhdd : "-" }}
              </div>
              <div class="row flex_vc">
                <div class="m_flex_box">
                  <span>报名结果公示期</span>
                  {{ checkStepTwo.bmjssj ? checkStepTwo.bmjssj : "-" }}至{{
                    checkStepTwo.announceEndTime
                      ? checkStepTwo.announceEndTime
                      : "-"
                  }}
                </div>
                <!-- <div>（结果公示期间接受咨询处理,咨询电话：0516-83601271）</div> -->
              </div>
              <div class="row m_flex_box flex_vc">
                <span>特别说明:</span>
                <div style="flex: 1">
                  <p>
                    1、预售办理完毕时,项目报名将同时关闭。如果出现APP报名未审核完毕的情况,则APP报名入口关闭,线下现场报名顺延一天。
                  </p>
                  <p>
                    2、当报名人数大于等于可售商品住宅房源数2倍时,将由公证处进行摇号确认购房名单及选房顺序;当报名人数小于可售商品住宅房源数2倍时,将交由开发企业自行销售。另外注意,如果当前项目是双限项目,上述2倍比例,将变为1倍。
                  </p>
                  <p>
                    3、报名进行中的报名序号会由于其他报名者的取消报名等操作而发生变动。请购房者以报名结束或摇号公示阶段的报名序号为准。
                  </p>
                </div>
              </div>
              <!-- <div class="row flex_vc">
                <span>序号说明:</span>
                <span style="color: red">
                  项目报名阶段的报名序号会由于其他报名者取消报名、无房证明验证失败等情况发生变动，请购房者以“摇号公示”阶段的报名序号为准。
                </span>
              </div> -->
              <div class="btn">
                <p @click="checkStep2List">查看报名列表</p>
                <p
                  @click="checkStep2SignUp(checkData.appApply)"
                  style="margin-top: 0.2rem; margin-bottom: 0.1rem"
                  v-if="checkData.appApply != 4"
                  :class="checkData.appApply == 2 ? '' : 'grey'"
                >
                  我要报名
                </p>
                <div v-if="checkData.appApply == 1">线上报名暂未开始</div>
                <div v-if="checkData.appApply == 3">线上报名已关闭</div>
                <div v-if="checkData.appApply != 4 && checkData.appApplyTime">
                  报名时间
                </div>
                <div v-if="checkData.appApply != 4">
                  {{ checkData.appApplyTime }}
                </div>
              </div>
              <div class="img_flex">
                <div>
                  <img src="@/assets/img/dyh.png" />
                  <p>关注"徐州市房地产信息网"抖音视频号,观看摇号直播</p>
                </div>
                <div>
                  <img src="@/assets/img/sph.png" />
                  <p>关注"徐州市房地产信息网"微信视频号,观看摇号直播</p>
                </div>
              </div>
            </div>
            <div class="lotter_list" v-show="selectedStep == 3">
              <div class="row m_flex_box flex_vc">
                <span>房源套数</span>
                {{ checkStepThree.kszzCount }}套(人才{{
                  checkStepThree.rcCount
                }},无住房{{ checkStepThree.wzfCount }},普通{{
                  checkStepThree.ptCount
                }})
              </div>
              <div class="row m_flex_box flex_vc">
                <span>当前报名人数</span>
                {{ checkStepThree.bmCount ? checkStepThree.bmCount : "-" }}
              </div>
              <div
                class="row m_flex_box flex_vc"
                v-if="checkStepThree.clfs == '公证处摇号'"
              >
                <span>处理方式</span>
                {{ checkStepThree.clfs ? checkStepThree.clfs : "-" }}
              </div>
              <div
                class="row m_flex_box flex_vc"
                v-if="checkStepThree.clfs == '公证处摇号'"
              >
                <span>摇号时间</span>
                {{ checkStepThree.jhyhsj ? checkStepThree.jhyhsj : "-" }}
              </div>
              <div
                class="row m_flex_box flex_vc"
                v-if="checkStepThree.clfs == '公证处摇号'"
              >
                <span>摇号地点</span>
                {{ checkStepThree.jhyhdd ? checkStepThree.jhyhdd : "-" }}
              </div>
              <div
                class="row m_flex_box flex_vc"
                v-if="checkStepThree.clfs == '公证处摇号'"
              >
                <span>选房认购时间</span>
                {{ checkStepThree.xfrgsj ? checkStepThree.xfrgsj : "-" }}
              </div>
              <div
                class="row flex_vc"
                v-if="checkStepThree.clfs == '公证处摇号'"
              >
                <div class="m_flex_box">
                  <span>摇号结果公示期</span>
                  {{ checkStepThree.jhyhsj ? checkStepThree.jhyhsj : "-" }}至{{
                    checkStepThree.xfrgsj ? checkStepThree.xfrgsj : "-"
                  }}
                </div>
                <!-- <div>（结果公示期间接受咨询处理,咨询电话：0516-83601271）</div> -->
              </div>
              <div
                class="row m_flex_box flex_vc"
                v-if="checkStepThree.clfs == '公证处摇号'"
              >
                <span>特别说明</span>
                <span>
                  公证处摇号过程将由徐州市房地产信息网抖音视频号及微信视频号全程直播
                </span>
              </div>
              <div
                class="row m_flex_box flex_vc"
                v-if="checkStepThree.clfs == '公证处摇号'"
              >
                <span>摇号说明</span>
                <div style="flex: 1">
                  <p>摇号分三轮进行。</p>
                  <p>
                    第一轮：确定第一批次购房名单及选房顺序。在有效报名的人才首套房家庭范围内，摇出排列顺序，即选房顺序。
                  </p>
                  <p>
                    第二轮：确定第二批次购房名单及选房顺序。在第一轮未入围的和有效报名的无住房家庭范围内，摇出排列顺序，即选房顺序。
                  </p>
                  <p>
                    第三轮：确定第三批次购房名单及选房顺序。在第一、二轮未入围的以及有效报名的普通购房人范围内，摇出排列顺序，即选房顺序。
                  </p>
                </div>
              </div>
              <div class="btn">
                <p @click="checkStep3List(checkStepThree)">{{ listName }}</p>
              </div>

              <div class="img_flex">
                <div>
                  <img src="@/assets/img/dyh.png" />
                  <p>关注"徐州市房地产信息网"抖音视频号,观看摇号直播</p>
                </div>
                <div>
                  <img src="@/assets/img/sph.png" />
                  <p>关注"徐州市房地产信息网"微信视频号,观看摇号直播</p>
                </div>
              </div>
            </div>
            <div class="lotter_list" v-show="selectedStep == 4">
              <div class="row m_flex_box flex_vc">
                <span>认购进度</span>
                {{ checkStepFour.rgRatio ? checkStepFour.rgRatio : "-" }}
              </div>
              <div class="row m_flex_box flex_vc">
                <span>房源套数</span>
                {{ checkStepFour.kszzCount ? checkStepFour.kszzCount : "-" }}
              </div>
              <div class="row m_flex_box flex_vc">
                <span>已认购人数</span>
                {{ checkStepFour.rgCount ? checkStepFour.rgCount : "-" }}
              </div>
              <div class="row m_flex_box flex_vc">
                <span>选房认购时间</span>
                {{ checkStepFour.xfrgsj ? checkStepFour.xfrgsj : "-" }}
              </div>
              <div class="row m_flex_box flex_vc">
                <span>选房认购地点</span>
                {{ checkStepFour.xfdd ? checkStepFour.xfdd : "-" }}
              </div>
              <div class="row m_flex_box flex_vc">
                <span>选房认购说明：</span>
                <div style="flex: 1">
                  <p>
                    1、开发企业组织购房人，依据摇号结果，按照第一轮、第二轮、第三轮摇出的排列顺序，依次在预约选房平台上选房。选房情况现场、网上实时滚动，选房名单公示期为3个工作日。
                  </p>
                  <p>
                    2、人才首套房家庭、无住房家庭选房比例按照当前可供房源数各15%提供房源（不足一套按一套计算）。购房者未在规定时间内选房的，视为自动放弃，前号放弃的，按该批次的后号（候选者）一次递补。
                  </p>
                  <p>
                    3、开发企业按照选房结果办理商品住房网上合同备案，合同备案后不在受理投诉。
                  </p>
                  <p>4、名单公示期间接受投诉</p>
                </div>
              </div>
              <div class="btn">
                <p @click="checkStep4List">查看认购列表</p>
              </div>
              <div class="img_flex">
                <div>
                  <img src="@/assets/img/dyh.png" />
                  <p>关注"徐州市房地产信息网"抖音视频号,观看摇号直播</p>
                </div>
                <div>
                  <img src="@/assets/img/sph.png" />
                  <p>关注"徐州市房地产信息网"微信视频号,观看摇号直播</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="pad_bottom"></div>
    <div class="footer_d m_flex_box flex_vc flex_jz">
      <div class="collect flex_v flex_hc flex_vc" @click="collectOption">
        <img :src="isCollect ? collected : collectNo" alt="" />
        <span>{{ isCollect ? "已收藏" : "收藏" }}</span>
      </div>
      <div class="btn_con m_flex_box">
        <a
          @click="callTo(obj.zxdh, 3, obj.itemId)"
          class="light flex_v flex_hc flex_vc"
        >
          <h5>电话咨询</h5>
          <p>专业客服为你服务</p>
        </a>
        <div class="dark flex_v flex_hc flex_vc" @click="toBuy">
          <h5>我要买房</h5>
          <p>一键搜全城</p>
        </div>
      </div>
    </div> -->
    <img class="to_top" @click="toTop" src="@/assets/img/toTop.png" alt="" />
    <div class="load_con m_flex_box flex_vc flex_hc" v-if="isLoading">
      <div class="inner flex_v flex_vc flex_hc">
        <van-loading />
        <p>加载中...</p>
      </div>
    </div>
    <van-overlay :show="show" @click="show = false" :lock-scroll="false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <h3>商品住房预约选房平台报名须知</h3>
          <p>
            1、用户在APP端报名时填写的资料必须真实有效，用户需对自己提供的资料真实性负责。
          </p>
          <p>
            2、用户提供的所有报名信息，需要开发商进行审核，审核通过之后，会进入预约选房平台，并获得相应的报名序号。如果审核失败，需重新报名。
          </p>
          <p>
            3、新项目开启现场报名的周期为至少3个工作日，APP端的报名通道会在项目现场报名结束的前一天关闭。
            <span>
              如果购房者未能及时通过APP进行报名，或者通过APP报名后审核未通过，购房者可以在随后的一天前往开发商处现场进行报名。
            </span>
          </p>
          <p>
            4、购房者的报名申请会在项目的报名阶段审核完毕，请在APP上关注您的审核状态。如出现异常情况，请与您的开发商联系。
          </p>
          <p>
            5、所有商品住房的预约选房进度公示请在
            “首页->公示公告->商品住房预约选房平台”
            之中查看。也可在首页和新房页面的“报名选房”入口查看。其他注意事项请查看购房者操作手册，下载处：徐州市房地产信息网网站->便民服务->下载中心。
          </p>
          <div class="describe">
            <van-checkbox v-model="checked" shape="square"
              >我已仔细阅读以上说明</van-checkbox
            >
          </div>
          <div class="btn">
            <p class="sure" @click="show = false">取消</p>
            <p :class="!checked ? 'mayNot' : 'sure_two'" @click="signUp">
              确定报名
            </p>
          </div>
        </div>
      </div>
    </van-overlay>
    <div class="describe">
          <van-checkbox v-model="checked" shape="square"
            >我已仔细阅读以上说明</van-checkbox
          >
        </div>
    <!-- <div
      class="overlay"
      v-show="show"
      @click="show = false"
    >
      <div class="block" @click.stop>
        <h3>商品住房预约选房平台报名须知</h3>
        <p>
          1、用户在APP端报名时填写的资料必须真实有效，用户需对自己提供的资料真实性负责。
        </p>
        <p>
          2、用户提供的所有报名信息，需要开发商进行审核，审核通过之后，会进入预约选房平台，并获得相应的报名序号。如果审核失败，需重新报名。
        </p>
        <p>
          3、新项目开启现场报名的周期为至少3个工作日，APP端的报名通道会在项目现场报名结束的前一天关闭。
          <span>
            如果购房者未能及时通过APP进行报名，或者通过APP报名后审核未通过，购房者可以在随后的一天前往开发商处现场进行报名。
          </span>
        </p>
        <p>
          4、购房者的报名申请会在项目的报名阶段审核完毕，请在APP上关注您的审核状态。如出现异常情况，请与您的开发商联系。
        </p>
        <p>
          5、所有商品住房的预约选房进度公示请在
          “首页->公示公告->商品住房预约选房平台”
          之中查看。也可在首页和新房页面的“报名选房”入口查看。
        </p>
        <div class="describe">
          <van-checkbox v-model="checked" shape="square"
            >我已仔细阅读以上说明</van-checkbox
          >
        </div>
        <div class="btn">
          <p class="sure" @click="show = false">取消</p>
          <p :class="!checked ? 'mayNot' : 'sure_two'" @click="signUp">
            确定报名
          </p>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
// const map1 = require("@/assets/img/map/1.png");
// const map2 = require("@/assets/img/map/2.png");
// const map3 = require("@/assets/img/map/3.png");
// const map4 = require("@/assets/img/map/4.png");
// const map5 = require("@/assets/img/map/5.png");
import qs from "qs";
import { ImagePreview } from "vant";
import topHeader from "@/components/header";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import { mapGetters } from "vuex";
export default {
  name: "ProjectDetail",
  data() {
    return {
      checked: false,
      show: false,
      currentState: "",
      isApp: sessionStorage.getItem("isApp") || false,
      isWx: sessionStorage.getItem("isWx") || false,
      wxAppToken: sessionStorage.getItem("wxAppToken") || false,
      listName: "查看报名列表",
      stepImg1: require("@/assets/img/lotterImg/1.png"),
      stepImgOne: require("@/assets/img/lotterImg/jiantou1.png"),
      stepImg2: require("@/assets/img/lotterImg/2.png"),
      stepImgTwo: require("@/assets/img/lotterImg/jiantou1.png"),
      stepImg3: require("@/assets/img/lotterImg/3.png"),
      stepImgThree: require("@/assets/img/lotterImg/jiantou1.png"),
      stepImg4: require("@/assets/img/lotterImg/4.png"),
      checkStepOne: {},
      checkStepTwo: {},
      checkStepThree: {},
      checkStepFour: {},
      clickStepNumber: 0,
      selectedStep: "",
      saleItemId: this.$route.query.saleItemId || "",
      isLoading: true,
      pic: require("@/assets/img/tx.jpg"),
      bgColor: "transparent",
      textColor: "#fff",
      tabIndex: 0,
      collected: require("@/assets/img/collect_.png"),
      collectNo: require("@/assets/img/collect.png"),
      // isCollect: 0,
      topSwiperIndex: 0,
      announceTab: 0,
      scale: 1,
      swiperOptionh: {
        on: {
          slideChangeTransitionStart: (data) => {
            this.topSwiperIndex = data.activeIndex;
          },
        },
        pagination: {},
      },
      swiperOptionv: {},
      zoom: 10,
      // markerList: [{ lng: 117.290313, lat: 34.209974 }],
      active: false,
      icon: require("@/assets/img/zulinxiangqing_ditu_icon.png"),
      // icon1: map1,
      center: {},
      options: {},
      local: null,
      show: false,
      infoPosition: {},
      infoWindow: "",
      zScore: 0,
      nearby: {
        center: {
          lat: 34.209974,
          lng: 117.290313,
        },
        radius: 2000,
      },
      mapList: [],
      offset: { height: -16, width: 0 },
      showPad: false,
      obj: {},
      itemId: this.$route.query.itemId || "",
      videoList: [], //视频
      swiperImg: [], //轮播图片
      personList: [], //经纪人
      hxList: [], //户型
      oneHouseList: [], //一房一价
      // newsList: [], //新闻
      // nktList: [], //鸟瞰图
      // announceArr: [], //预售现售
      // announceArr1: [], //预售现售
      // showAnnounce: false,
      // showAnnounce1: false,
      checkData: {},
      // checkObj1: {},
      argumentList: [],
      ad: "",
      // scoreObj: {
      //   score2: 0,
      //   score3: 0,
      //   score4: 0,
      //   zScore: 0,
      //   score1: 0,
      // },
      recommendList: [],
      oldList: [],
      nktCurrent: 0,
      hxIndex: 0,
    };
  },
  components: {
    topHeader,
    Swiper,
    SwiperSlide,
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  // watch: {
  //   userInfo: {
  //     handler(n) {
  //       console.log(n);
  //       if (n.realName) {
  //         this.getCollect();
  //       }
  //     },
  //     deep: true,
  //   },
  // },
  provide() {
    return {
      reload: this.reload,
    };
  },
  filters: {
    capitalize: function (str) {
      if (str) {
        var starttime = str.replace(new RegExp("-", "gm"), "/");
        var starttimeHaoMiao = new Date(starttime).getTime();
        var starttimeHaoMiaoTwo = starttimeHaoMiao + 86400000 * 3;
        var year = new Date(starttimeHaoMiao).getFullYear();
        var month = new Date(starttimeHaoMiao).getMonth() + 1;
        var day = new Date(starttimeHaoMiao).getDate();
        var year1 = new Date(starttimeHaoMiaoTwo).getFullYear();
        var month1 = new Date(starttimeHaoMiaoTwo).getMonth() + 1;
        var day1 = new Date(starttimeHaoMiaoTwo).getDate();
        return (
          year +
          "-" +
          month +
          "-" +
          day +
          "至" +
          year1 +
          "-" +
          month1 +
          "-" +
          day1
        );
      } else {
        return "-";
      }
    },
    timeFormat(dates, fmt) {
      if (dates) {
        var date = new Date(dates);
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        }
        var o = {
          "M+": date.getMonth() + 1,
          "d+": date.getDate(),
          "h+": date.getHours(),
          "m+": date.getMinutes(),
          "s+": date.getSeconds(),
        };
        for (var k in o) {
          if (new RegExp("(" + k + ")").test(fmt)) {
            var str = o[k] + "";
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length === 1 ? str : ("00" + str).substr(str.length)
            );
          }
        }
        return fmt;
      } else {
        return "-";
      }
    },
    // formatwan(param) {
    //   if (param >= 10000) {
    //     return (param / 10000).toFixed(2) + "w";
    //   } else {
    //     return param;
    //   }
    // },
  },
  created() {
    document
      .querySelector('meta[name="viewport"]')
      .setAttribute(
        "content",
        "width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=0,viewport-fit=cover"
      );
    //             this.itemId = this.$route.query.itemId;
    // this.saleItemId = this.$route.query.saleItemId;
    this.getLotteryInfo();
  },
  inject: ["reload", "judgeApp"],
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.getDetails();
    this.getAllPer();
    this.getOnehouse();
    // this.getNews();
    // this.getNkt();
    // this.getAnnounce();
    // this.getAnnounce1();
    // this.getArgument();
    this.getRecommend();
    // this.getOld();
    // this.getAd();

    // if (this.userInfo.realName) {
    //   this.getCollect();
    // }
  },
  methods: {
    // goBack() {
    //   window.webkit.messageHandlers.goback.postMessage(null);
    // },
    checkStep2List() {
      this.$router.push({
        path: "/lotterySignUp",
        query: {
          saleItemId: this.saleItemId,
        },
      });
    },
    checkStep2SignUp(appApply) {
      if (appApply == 2) {
        this.show = true;
      }
    },
    signUp() {
      if (this.checked) {
        if (this.isApp) {
          var tooken = "";
          var ua = navigator.userAgent;
          var uaList = ua.split(" ");
          for (var i = 0; i < uaList.length; i++) {
            if (uaList[i].indexOf("token") > -1) {
              tooken = uaList[i].split("=")[1];
              break;
            }
          }
          if (tooken) {
            this.$router.push({
              path: "/myLotterySignUp",
              query: {
                saleItemID: this.saleItemId,
                isApp: true,
              },
            });
          } else {
            if (this.judgeApp() == "isIOS") {
              window.webkit.messageHandlers.checkLogin.postMessage(null);
            } else {
              window.android.checkLogin();
            }
          }
        } else {
          if (this.isWx) {
            if (!this.wxAppToken) {
              uni.navigateTo({
                url: `/pages/index/login`,
              });
            } else {
              this.$router.push({
                path: "/myLotterySignUp",
                query: {
                  saleItemID: this.saleItemId,
                  isApp: true,
                },
              });
            }
          } else {
            this.$router.push({
              path: "/myLotterySignUp",
              query: {
                saleItemID: this.saleItemId,
              },
            });
          }
        }
      }
    },
    checkStep4List() {
      this.$router.push({
        path: "/lotteryConfirm",
        query: {
          saleItemId: this.saleItemId,
        },
      });
    },
    checkStep3List(item) {
      if (item.clfs == "公证处摇号" && item.sfdryhb == 1) {
        this.$router.push({
          path: "/lotteryResult",
          query: {
            saleItemId: this.saleItemId,
          },
        });
      } else {
        this.$router.push({
          path: "/lotterySignUp",
          query: {
            saleItemId: this.saleItemId,
          },
        });
      }
    },
    clickStep1() {
      if (this.clickStepNumber >= 1) {
        this.currentState = "项目正在进行预售许可办理，报名即将开始";
        this.selectedStep = 1;
      }
    },
    clickStep2() {
      if (this.clickStepNumber >= 2) {
        this.selectedStep = 2;
        this.currentState = "报名进行中，请注意报名开始和结束时间。";
      }
    },
    clickStep3() {
      if (this.clickStepNumber >= 3) {
        this.selectedStep = 3;
        if (this.checkStepThree.clfs == "公证处摇号") {
          this.currentState =
            "报名人数大于等于可售商品房住宅数量的2倍(双限项目为1倍)，将由公证处进行摇号确认购房名单及选房顺序";
        } else {
          this.currentState =
            "报名人数小于可售商品住宅房源数2倍(双限项目为1倍)，将交由开发企业自行销售。";
        }
      }
    },
    clickStep4() {
      if (this.clickStepNumber == 4) {
        this.selectedStep = 4;
        this.currentState = "开发企业根据选房名单进行房源认购。";
      }
    },
    getLotteryInfo() {
      this.$http
        .post(
          "house/api/ysbm/yhjdgs.do",
          qs.stringify({
            saleItemId: this.saleItemId,
          })
        )
        .then((res) => {
          if (res.code == "000") {
            this.checkData = Object.assign(res.result.ysInfo, {});
            this.checkStepOne = Object.assign(res.result, {});
            this.checkStepTwo = Object.assign(res.result, {});
            if (this.itemId == "e6e29a4dc51e472bbf401a8bea95be07") {
              this.checkStepTwo.bmjssj = "2021-12-05 18:00:00";
              this.checkStepTwo.bmkssj = "2021-12-05 8:00:00";
            }
            this.checkStepThree = Object.assign(res.result, {});
            this.checkStepFour = Object.assign(res.result, {});
            if (res.result.jdStatus == "预售办理中") {
              this.selectedStep = 1;
              this.clickStepNumber = 1;
              this.currentState = "项目正在进行预售许可办理，报名即将开始";
              this.stepImg1 = require("@/assets/img/lotterImg/01.png");
            }
            if (res.result.jdStatus == "报名中") {
              this.selectedStep = 2;
              this.clickStepNumber = 2;
              this.currentState = "报名进行中，请注意报名开始和结束时间。";
              this.stepImg1 = require("@/assets/img/lotterImg/01.png");
              this.stepImg2 = require("@/assets/img/lotterImg/02.png");
              this.stepImgOne = require("@/assets/img/lotterImg/jiantou2.png");
            }
            if (res.result.jdStatus == "摇号公示") {
              this.selectedStep = 3;
              this.clickStepNumber = 3;
              this.currentState =
                "报名人数小于可售商品住宅房源数2倍(双限项目为1倍)，将交由开发企业自行销售。";
              this.stepImg1 = require("@/assets/img/lotterImg/01.png");
              this.stepImg2 = require("@/assets/img/lotterImg/02.png");
              this.stepImg3 = require("@/assets/img/lotterImg/03.png");
              this.stepImgOne = require("@/assets/img/lotterImg/jiantou2.png");
              this.stepImgTwo = require("@/assets/img/lotterImg/jiantou2.png");
              if (
                res.result.clfs != "开发企业自行销售" &&
                res.result.sfdryhb == 1
              ) {
                this.listName = "查看摇号列表";
                this.currentState =
                  "报名人数大于等于可售商品房住宅数量的2倍(双限项目为1倍)，将由公证处进行摇号确认购房名单及选房顺序。";
              }
            }
            if (res.result.jdStatus == "认购公示") {
              this.selectedStep = 4;
              this.clickStepNumber = 4;
              this.currentState = "开发企业根据选房名单进行房源认购";
              this.stepImg1 = require("@/assets/img/lotterImg/01.png");
              this.stepImg2 = require("@/assets/img/lotterImg/02.png");
              this.stepImg3 = require("@/assets/img/lotterImg/03.png");
              this.stepImg4 = require("@/assets/img/lotterImg/04.png");
              this.stepImgOne = require("@/assets/img/lotterImg/jiantou2.png");
              this.stepImgTwo = require("@/assets/img/lotterImg/jiantou2.png");
              this.stepImgThree = require("@/assets/img/lotterImg/jiantou2.png");
              if (
                res.result.clfs != "开发企业自行销售" &&
                res.result.sfdryhb == 1
              ) {
                this.listName = "查看摇号列表";
              }
            }
          }
        });
    },

    //toCall(item.id,item.zxdh,1)
    //window.location.href = domains + '/#' + 'houseDetail?houseListedId='+item.listedId+'&mainId='+item.houseListed.mainId

    // toOneHouseOnePrice(itemId) {
    //   this.$router.push({
    //     path: "/oneHouseOnePrice",
    //     query: { itemId },
    //   });
    // },
    // toDetail(itemId, houseId) {
    //   this.$router.push({
    //     path: "/oneHouseOnePriceDetail",
    //     query: { itemId, houseId },
    //   });
    // },
    // collectOption() {
    //   this.$http
    //     .post(
    //       "cms/houseCollect/reg/addNewHouseCollect.do",
    //       qs.stringify({
    //         itemId: this.itemId,
    //       })
    //     )
    //     .then((res) => {
    //       this.$toast(res.msg);
    //       if (res.success) {
    //         if (res.msg === "已为您成功添加收藏") {
    //           this.isCollect = 1;
    //         } else {
    //           this.isCollect = 0;
    //         }
    //       }
    //     });
    // },
    // getCollect() {
    //   this.$http
    //     .post(
    //       "cms/houseCollect/reg/getNewHouseCollect.do",
    //       qs.stringify({
    //         itemId: this.itemId,
    //       })
    //     )
    //     .then((res) => {
    //       if (res.success) {
    //         this.isCollect = res.obj;
    //       }
    //     });
    // },
    toProject() {
      this.$router.push({
        path: "/projectDetail",
        query: {
          itemId: this.itemId,
        },
      });
    },
    // getDetail(itemId, old) {
    //   if (old == 1) {
    //     this.$router.push({
    //       path: "/projectDetailIndex",
    //       query: {
    //         itemId: itemId,
    //       },
    //     });
    //   } else {
    //     this.$router.push({
    //       path: "/projectDetail",
    //       query: {
    //         itemId: itemId,
    //       },
    //     });
    //     this.reload();
    //   }
    // },

    getDetails() {
      this.$new
        .post(
          "itemInfo/getItemById.do",
          qs.stringify({
            id: this.itemId || "dd6b800b1d2d4144840ec1e2144b5bcc",
          })
        )
        .then((res) => {
          var Img = this.logoImg;
          var url = window.location.href;
          var hosts = url.split("/#/")[0]; //获取域名加打包文件夹名称
          var shareImg = hosts.concat("/" + Img);
          this.$share(res.obj.tgmc, res.obj.ms, shareImg);
          this.isLoading = false;
          this.obj = res.obj;
          this.zScore = res.obj.zScore;
          this.center = {
            lng: res.obj.zb.split(",")[0],
            lat: res.obj.zb.split(",")[1],
          };
          this.zoom = 15;
          this.$set(this.nearby.center, "lng", res.obj.zb.split(",")[0]);
          this.$set(this.nearby.center, "lat", res.obj.zb.split(",")[1]);
          this.videoList = res.obj.video;
          const imgArr = [];
          for (let i = 0; i < res.obj.img.length; i++) {
            for (let j = 0; j < res.obj.img[i].imgList.length; j++) {
              imgArr.push(res.obj.img[i].imgList[j]);
            }
          }
          this.swiperImg = imgArr;
          res.obj.img.forEach((item, index) => {
            if (item.name === "户型效果图") {
              this.hxList = item.imgList || [];
              this.hxIndex = index;
            }
          });
        });
    },
    getBroker() {
      return new Promise((resolve) => {
        this.$http
          .post(
            "cms/broker/permit/getItemBrokerList.do",
            qs.stringify({
              itemId: this.itemId || "dd6b800b1d2d4144840ec1e2144b5bcc",
            })
          )
          .then((res) => {
            resolve(res.obj);
          });
      });
    },
    getZy() {
      return new Promise((resolve) => {
        this.$new
          .post(
            "sale/getZygwList.do",
            qs.stringify({
              itemId: this.itemId || "dd6b800b1d2d4144840ec1e2144b5bcc",
            })
          )
          .then((res) => {
            resolve(res.obj);
          });
      });
    },
    getAllPer() {
      Promise.all([this.getBroker(), this.getZy()]).then((res) => {
        let newArr = [];
        if (res[0]) {
          newArr = newArr.concat(res[0]);
        }
        if (res[1]) {
          newArr = newArr.concat(res[1]);
        }
        this.personList = newArr;
      });
    },
    getOnehouse() {
      this.$new
        .post(
          "houseApi/getHouseList.do",
          qs.stringify({
            itemId: this.itemId,
            type: 2,
            order: 1,
            pageSize: 2,
            currPageNo: 1,
            xzqh: this.main.getHostArea(),
          })
        )
        .then((res) => {
          this.oneHouseList = res.obj || [];
        });
    },
    // getNews() {
    //   this.$new
    //     .post(
    //       "itemInfo/getItemNewsById.do",
    //       qs.stringify({
    //         pageSize: 2,
    //         currPageNo: 1,
    //         itemId: this.itemId || "7c2bf0da11494dd798cc447dc3cb2cc8",
    //       })
    //     )
    //     .then((res) => {
    //       this.newsList = res.obj || [];
    //     });
    // },
    // getNkt() {
    //   this.$new
    //     .post(
    //       "itemInfo/getAerialViewByItem.do",
    //       qs.stringify({
    //         itemId: this.itemId || "5f66988446724e67a3a78fbfee65d2ce",
    //       })
    //     )
    //     .then((res) => {
    //       this.nktList = res.obj || [];
    //     });
    // },
    // getAnnounce() {
    //   this.$new
    //     .post(
    //       "salePermit/getYsxxByItemId.do",
    //       qs.stringify({
    //         itemId: this.itemId || "dd6b800b1d2d4144840ec1e2144b5bcc",
    //       })
    //     )
    //     .then((res) => {
    //       this.announceArr = res.obj || [];
    //       if (res.obj) {
    //         this.checkObj = res.obj[0];
    //       }
    //     });
    // },
    // getAnnounce1() {
    //   this.$new
    //     .post(
    //       "estRecord/getXsxxByItemId.do",
    //       qs.stringify({
    //         itemId: this.itemId,
    //       })
    //     )
    //     .then((res) => {
    //       this.announceArr1 = res.obj || [];
    //       if (res.obj) {
    //         this.checkObj1 = res.obj[0];
    //       }
    //     });
    // },
    // getArgument() {
    //   this.$new
    //     .post(
    //       "itemInfo/getCommentByPage.do",
    //       qs.stringify({
    //         pageSize: 2,
    //         currPageNo: 1,
    //         xzqh: this.main.getHostArea(),
    //         contentType: 1,
    //         itemId: this.itemId || "dd6b800b1d2d4144840ec1e2144b5bcc",
    //       })
    //     )
    //     .then((res) => {
    //       this.argumentList = res.obj || [];
    //       if (res.attributes) {
    //         this.scoreObj = res.attributes.avgScore;
    //       }
    //     });
    // },
    getRecommend() {
      this.$new
        .post(
          "promoteHouse/getTypePage.do",
          qs.stringify({
            pageSize: 4,
            currPageNo: 1,
            xzqh: this.main.getHostArea(),
            type: 4,
          })
        )
        .then((res) => {
          this.recommendList = res.obj || [];
        });
    },
    getOld() {
      this.$http({
        url: "cms/houseListed/permit/getHouseList.do",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          area: this.main.getHostArea(),
          offset: 0,
          pageSize: 4,
          sort: 0,
          itemId: this.itemId,
        },
      }).then((res) => {
        this.oldList = res.obj ? res.obj.rows : [];
      });
    },
    setNkt(index) {
      this.nktCurrent = index;
    },
    // confirm(data) {
    //   this.checkObj = data;
    //   this.showAnnounce = false;
    // },
    // confirm1(data) {
    //   this.checkObj1 = data;
    //   this.showAnnounce1 = false;
    // },
    toNews(id) {
      this.$router.push({
        path: "/newsDetail",
        query: {
          id,
        },
      });
    },
    toImg() {
      this.$router.push({
        path: "/photo",
        query: {
          itemId: this.itemId,
          index: this.videoList.length ? this.hxIndex + 1 : this.hxIndex,
        },
      });
    },
    toOld(obj) {
      this.$router.push({
        path: "/houseDetail",
        query: {
          houseListedId: obj.id,
          mainId: obj.mainId,
        },
      });
    },
    toOneHouse() {
      this.$router.push({
        path: "/oneHouseOnePrice",
        query: {
          itemId: this.itemId,
        },
      });
    },
    handler({ BMap, map }) {
      this.map = map;
    },
    search(data) {
      this.$set(this, "mapList", data.Ar);
    },
    setCenter(data) {
      this.$set(this.center, "lng", data.marker.point.lng);
      this.$set(this.center, "lat", data.marker.point.lat);
      this.getPane(data);
      this.zoom = 15;
    },
    infoWindowOpen(e) {
      this.show = true;
    },
    infoWindowClose(e) {
      this.show = false;
    },
    // 获取广告
    getAd() {
      this.$new
        .post(
          "ad/getAdList.do",
          qs.stringify({
            xzqh: this.main.getHostArea(),
            type: 5,
          })
        )
        .then((res) => {
          if (res.obj) {
            this.ad = res.obj;
          }
          // this.offsetTop = document.querySelector('.tab_con').offsetTop
        });
    },
    getPane(data) {
      this.$set(this.infoPosition, "lng", data.marker.point.lng);
      this.$set(this.infoPosition, "lat", data.marker.point.lat);
      this.infoWindowOpen();
      this.infoWindow = `<div><h5>${data.title}</h5><p>${data.address}</p></div>`;
    },
    toTop() {
      this.$refs.topBanner.scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "start", // 上边框与视窗顶部平齐。默认值
      });
    },
    toSlide(index) {
      if (this.videoList.length) {
        this.$refs.mySwiper.$swiper.slideTo(index, 200);
      } else {
        this.$refs.mySwiper.$swiper.slideTo(index - 1, 200);
      }
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > (document.documentElement.clientWidth / 7.5) * 5.6) {
        this.textColor = "#fff";
        this.bgColor = "transparent";
      } else {
        this.textColor = "#fff";
        this.bgColor = "transparent";
      }
    },
    showImg(list, index) {
      const newArr = [];
      list.forEach((item) => {
        newArr.push("data:image/jpg;base64," + item);
      });
      ImagePreview({
        images: newArr,
        startPosition: index,
      });
    },
    showModel(parent, index) {
      this.$router.push({
        path: "/photo",
        query: {
          itemId: this.itemId,
        },
      });
    },
    toUrl(path, type) {
      this.$router.push({
        path,
        query: {
          itemId: this.itemId,
          type: type || "",
        },
      });
    },
  },
  destroyed() {
    document
      .querySelector('meta[name="viewport"]')
      .setAttribute(
        "content",
        "width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=0"
      );
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.block {
  overflow: auto;
  background: #fff;
  border-radius: 10px;
  padding: 0 0.2rem;
  width: 80%;
  height: 80%;
  background-color: #fff;
  h3 {
    font-size: 0.4rem;
    text-align: center;
    padding: 0.5rem 0;
    font-weight: 900;
  }
  p {
    margin-bottom: 0.2rem;
    font-size: 0.3rem;
    text-align: left;
    span {
      font-weight: 900;
    }
  }
  .describe {
    padding: 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn {
    padding: 0.5rem 0;
    display: flex;
    justify-content: space-around;
    p {
      border-radius: 5px;
      width: 2rem;
      padding: 0.1rem 0;
      text-align: center;
      font-size: 0.3rem;
    }
    .sure {
      border: 1px solid #64b5f6;
      color: #64b5f6;
    }
    .sure_two {
      border: 1px solid #64b5f6;
      background: #64b5f6;
      color: #fff;
    }
    .mayNot {
      border: 1px solid #ccc;
      color: #ccc;
    }
  }
}
// .overlay {
//   position: fixed;
//   top: 0;
//   left: 0;
//   bottom: 0;
//   top: 0;
//   right: 0;
//   background: rgba(0, 0, 0, 0.7);
//   z-index: 2000;
//   .block {
//     overflow: auto;
//     background: #fff;
//     position: absolute;
//     left: 50%;
//     transform: translateX(-50%);
//     top: 10%;
//     border-radius: 10px;
//     padding: 0 0.2rem;
//     width: 80%;
//     height: 80%;
//     background-color: #fff;
//     h3 {
//       font-size: 0.4rem;
//       text-align: center;
//       padding: 0.5rem 0;
//       font-weight: 900;
//     }
//     p {
//       margin-bottom: 0.2rem;
//       font-size: 0.3rem;
//       text-align: left;
//       span {
//         font-weight: 900;
//       }
//     }
//     .describe {
//       padding: 10px 0;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//     }
//     .btn {
//       padding: 0.5rem 0;
//       display: flex;
//       justify-content: space-around;
//       p {
//         border-radius: 5px;
//         width: 2rem;
//         padding: 0.1rem 0;
//         text-align: center;
//         font-size: 0.3rem;
//       }
//       .sure {
//         border: 1px solid #64b5f6;
//         color: #64b5f6;
//       }
//       .sure_two {
//         background: #64b5f6;
//         border: 1px solid #64b5f6;
//         color: #fff;
//       }
//       .mayNot {
//         border: 1px solid #ccc;
//         color: #ccc;
//       }
//     }
//   }
// }

.describe {
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.m_flex_lotter li {
  height: 1.6rem;
  padding-bottom: 1rem;
  display: flex;
  .lotter_point {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    img {
      width: 90%;
    }
    .line {
      position: absolute;
      top: 1.6rem;
      left: 0.25rem;
      height: 1.1rem;
      width: 0.8rem;
      img {
        height: 100%;
      }
    }
  }
  .lotter_step {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    flex: 1;
  }
  .lotter_dec {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    flex: 3;
  }
}
.m_dec {
  border: 1px solid #ccc;
  padding: 0.5rem 0.3rem;
  .lotter_list {
    .row {
      border-bottom: 1px solid #f5f5f5;
      font-size: 0.24rem;
      color: #8f8f8f;
      padding: 0.2rem 0;
      span {
        font-size: 0.26rem;
        font-weight: 800;
        width: 2.6rem;
        color: #8f8f8f;
      }
    }
    .btn {
      padding-top: 0.5rem;
      p {
        margin: 0 auto;
        width: 30%;
        text-align: center;
        padding: 0.2rem 0.4rem;
        color: #fff;
        background-color: #007fff;
      }
      div {
        text-align: center;
        color: #ccc;
      }
      .grey {
        background-color: #ccc;
      }
    }
    .img_flex {
      margin-top: 0.5rem;
      display: flex;
      div {
        text-align: center;
        flex: 1;
        img {
          width: 2rem;
          height: 2rem;
        }
      }
    }
  }
}
.load_con {
  position: fixed;
  z-index: 9999;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  color: #fff;
  font-size: 14px;
  .inner {
    background-color: rgba(0, 0, 0, 1);
    padding: 16px;
    width: 88px;
    max-width: 70%;
    min-height: 88px;
    border-radius: 8px;
  }
  p {
    margin-top: 8px;
  }
}
video {
  height: 5.64rem;
  width: 100%;
  background-color: #000;
}
.top_banner {
  position: relative;
  height: 5.64rem;
  .total {
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 0.24rem;
    width: 1.2rem;
    line-height: 0.5rem;
    position: absolute;
    bottom: 0.24rem;
    right: 0.4rem;
    z-index: 9;
    text-align: center;
    border-radius: 0.25rem;
  }
  img {
    height: 5.64rem;
    width: 100%;
  }
  .slide_video_con {
    position: relative;
    .cover {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 5.64rem;
      background-color: rgba(0, 0, 0, 0.3);
      i {
        color: #fff;
        font-size: 1.4rem;
      }
    }
  }
}
.pagination {
  position: absolute;
  z-index: 9;
  bottom: 0.3rem;
  left: 0;
  right: 0;
  span {
    width: 0.76rem;
    line-height: 0.36rem;
    text-align: center;
    font-size: 0.22rem;
    margin: 0 0.1rem;
    background-color: #e6e6e6;
    color: #101010;
    border-radius: 0.18rem;
    &.active {
      background-color: #3072f5;
      color: #fff;
    }
  }
}
.top_info {
  width: 7.04rem;
  margin: 0.34rem auto;
  .top {
    margin-bottom: 0.24rem;
  }
  h3 {
    font-size: 0.38rem;
    font-weight: 800;
    width: 60%;
  }
  .price {
    font-size: 0.24rem;
    white-space: nowrap;
    span {
      color: #ff4532;
      font-size: 0.36rem;
    }
  }
  .score {
    img {
      width: 0.22rem;
      height: 0.22rem;
      margin-right: 0.06rem;
    }
    span {
      margin-left: 0.08rem;
    }
  }
  .fwl {
    font-size: 0.24rem;
    color: #909090;
    span {
      color: #101010;
      margin-left: 0.06rem;
    }
  }
  .icon {
    font-size: 0.22rem;
    margin-top: 0.3rem;
    span,
    i {
      padding: 0 0.1rem;
      line-height: 0.42rem;
      border-radius: 0.02rem;
      display: block;
    }
    span {
      background-color: #3072f5;
      color: #fff;
    }
    i {
      background-color: #ededed;
      margin-left: 0.08rem;
      color: #666;
    }
  }
  .middle_blue {
    margin-top: 0.44rem;
    height: 0.82rem;
    padding: 0 0.22rem;
    background-color: #eef4ff;
    img {
      margin-right: 0.1rem;
    }
    .left {
      img {
        width: 0.26rem;
        span {
          font-size: 0.26rem;
          i {
            font-weight: 800;
            font-size: 0.3rem;
          }
        }
      }
    }
    .right,
    .left {
      img {
        width: 0.32rem;
        height: 0.3rem;
      }
      span {
        color: #3072f5;
        font-weight: 800;
      }
    }
  }
}
.text_con {
  width: 7.04rem;
  margin: 0 auto;
  font-size: 0.26rem;
  color: #919191;
  span {
    color: #101010;
    max-width: 5.42rem;
    margin-left: 0.2rem;
  }
  .row {
    margin-bottom: 0.2rem;
  }
}
.detail_nav_bar {
  &.fixed {
    background-color: #fff;
    position: fixed;
    top: 0.9rem;
    left: 0;
    right: 0;
    z-index: 2;
    border-top: 1px solid #e9e9e9;
  }
  white-space: nowrap;
  overflow: scroll;
  span {
    font-weight: 800;
    display: inline-block;
    padding: 0 0.3rem;
    font-size: 0.3rem;
    line-height: 0.9rem;
    position: relative;
    &.active {
      color: #3072f5;
      font-size: 0.32rem;
      &:after {
        content: "";
        display: block;
        position: absolute;
        width: 0.48rem;
        height: 0.04rem;
        background-color: #3072f5;
        border-radius: 0.02rem;
        left: 50%;
        margin-left: -0.24rem;
        bottom: 0.1rem;
      }
    }
  }
}
.main_inner {
  width: 7.04rem;
  margin: 0 auto;
  display: block;
  padding: 0.4rem 0;
  .tit_con {
    margin-bottom: 0.28rem;
  }
  .inner_tit {
    font-size: 0.34rem;
    font-weight: 800;
  }
  .arrow {
    color: #aaabae;
    font-size: 0.24rem;
    i {
      margin-left: 0.12rem;
    }
  }
  .text_con {
    line-height: 0.42rem;
  }
}
.people_con {
  white-space: nowrap;
  overflow: auto;
  padding: 0.48rem 0.08rem 0.08rem;
  .inner {
    display: inline-block;
    width: 2.7rem;
    height: 3.04rem;
    box-sizing: border-box;
    box-shadow: 0rem 0.02rem 0.08rem rgba(0, 0, 0, 0.15);
    border-radius: 0.04rem;
    padding: 0 0.2rem;
    box-sizing: border-box;
    margin-right: 0.16rem;
    text-align: center;
    &:last-child {
      margin-right: 0;
    }
    .atavr {
      position: relative;
      top: -0.48rem;
      width: 1.3rem;
      height: 1.3rem;
      border-radius: 50%;
      display: block;
      margin: 0 auto;
    }
    .name {
      font-size: 0.26rem;
      margin-top: -0.34rem;
      font-weight: 800;
    }
    .intro {
      font-size: 0.26rem;
      margin: 0.08rem 0 0.14rem;
    }
    .btn_con {
      width: 100%;
      padding-top: 0.12rem;
      border-top: 1px solid #f4f4f4;
      text-align: center;
      font-size: 0.22rem;
      color: #606060;
      img {
        width: 0.4rem;
        height: 0.4rem;
      }
    }
  }
}
.ad_con {
  padding-top: 0.3rem;
  img {
    height: 1.68rem;
    width: 100%;
    display: block;
  }
}

.announce_list {
  .row {
    height: 0.76rem;
    border-bottom: 1px solid #f5f5f5;
    font-size: 0.24rem;
    color: #8f8f8f;
    span {
      font-size: 0.26rem;
      font-weight: 800;
      width: 2.6rem;
      color: #8f8f8f;
    }
  }
}
.announce_main {
  .btn_con {
    margin-top: 0.3rem;
    span {
      width: 2.26rem;
      line-height: 0.66rem;
      font-size: 0.24rem;
      font-weight: 800;
      color: #3072f5;
      text-align: center;
      background-color: #f2f7ff;
    }
  }
}
.bm-view {
  width: 100%;
  height: 3.88rem;
}
.map_tab_con {
  white-space: nowrap;
  margin-bottom: 0.3rem;
  overflow: auto;
  span {
    display: inline-block;
    font-size: 0.26rem;
    font-weight: 800;
    background-color: #f0f0f0;
    line-height: 0.56rem;
    width: 1.2rem;
    border-radius: 0.28rem;
    text-align: center;
    margin-right: 0.1rem;
    &.active {
      background-color: #e8f0ff;
      color: #2f72f5;
    }
  }
}

.footer_d {
  background-color: #fff;
  left: 0;
  right: 0;
  position: fixed;
  height: 0.98rem;
  padding: 0 0.12rem;
  bottom: 0;
  border-top: 1px solid #f0f0f0;
  .collect {
    width: 1.4rem;
    img {
      width: 0.36rem;
    }
    span {
      font-size: 0.24rem;
      color: #636363;
      margin-top: 0.1rem;
    }
  }
  .btn_con {
    > div,
    > a {
      width: 2.88rem;
      height: 0.84rem;
      color: #fff;
      border-radius: 0.06rem;
      h5 {
        font-size: 0.24rem;
        font-weight: 800;
      }
      p {
        font-size: 0.22rem;
      }

      &.light {
        background-color: #17c5fb;
        margin-right: 0.12rem;
      }
      &.grey {
        background-color: #2f72f5;
      }
    }
  }
}
.pad_bottom {
  padding-top: 0.6rem;
}
.mid_pad {
  padding-top: 0.92rem;
}
.to_top {
  width: 0.84rem;
  height: 0.84rem;
  position: fixed;
  z-index: 8;
  right: 0.15rem;
  bottom: 2rem;
}
</style>